import { Image, InlineStack } from '@customerio/pluma-components/react';
import { integrationImageSrc } from '@/features/integrations';

/**
 * mParticle is a static catalog entry, so there is no fetched row to read a logo
 * from. Feeding its homepage through the shared resolver keeps the Brandfetch
 * URL in one place instead of hardcoding a second copy here — Hydra's version
 * omits the sizing and client-id query Ember's carried.
 */
const MPARTICLE_LOGO_SRC = integrationImageSrc({
  id: 'mparticle',
  type: '',
  image_url: undefined,
  homepage: 'https://www.mparticle.com/',
});

type MParticleHeaderTitleProps = {
  title: string;
};

/** The connector's lettermark beside the page name, as Ember rendered it. */
export function MParticleHeaderTitle({ title }: MParticleHeaderTitleProps) {
  return (
    <InlineStack alignBlock="center" gap="100">
      <Image src={MPARTICLE_LOGO_SRC} alt="" size="icon-v2-xl" objectFit="contain" />
      {title}
    </InlineStack>
  );
}
